import { DEFAULT_COOKIE_OPTIONS } from '@src/consts/cookies';
import { ssrWrapper } from './ssr';

export interface ICookieOptions {
  path?: string;
  expires?: Date | string;
  ['max-age']?: number;
  domain?: string | boolean;
}

type TCookieFn<T = void> = (name: string, value: string, options: ICookieOptions) => T;

export const removeCookie = ssrWrapper(
  (name: string, options: ICookieOptions = {}) => {
    setCookie(name, '', {
      ...DEFAULT_COOKIE_OPTIONS,
      ...options,
      'max-age': -1,
    });
  },
  () => {},
);

export const getCookieString: TCookieFn<string> = (name, value, options = {}) => {
  const currentOptions = {
    ...DEFAULT_COOKIE_OPTIONS,
    ...options,
  };

  if (currentOptions.expires instanceof Date) {
    options.expires = currentOptions.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

  for (const optionKey in currentOptions) {
    const optionValue = currentOptions[optionKey];

    if (optionValue !== false) {
      updatedCookie += '; ' + optionKey;

      if (optionValue !== true) {
        updatedCookie += '=' + optionValue;
      }
    }
  }

  return updatedCookie;
};

export const setCookie: TCookieFn = (name, value, options) => {
  const cookieString = getCookieString(name, value, options);

  if (cookieString) {
    document.cookie = cookieString;
  }
};

export const getCookie = ssrWrapper<(n: string) => string | undefined, (n: string) => string | undefined>(
  (name: string) => {
    const matches = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'),
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  },
  () => '',
);

export const getTokenMinuteExpires = (minutes: number, isDate?: boolean) => {
  const expires = new Date();
  expires.setMinutes(expires.getMinutes() + minutes);

  return isDate ? expires : expires.toUTCString();
};
